import { render, staticRenderFns } from "./PageWebPaymentSetupAccountAllianz.vue?vue&type=template&id=737a9234"
import script from "./PageWebPaymentSetupAccountAllianz.vue?vue&type=script&lang=js"
export * from "./PageWebPaymentSetupAccountAllianz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports